<template>
  <div class="centerCenter">
    <div class="container text-center">
      <router-link to="/">
        <img
          class="d-block mx-auto mb-4"
          src="../assets/logo_default.svg"
          alt
          width="100"
          height="100"
        />
      </router-link>

      <form id="signinform" class="form-signin" @submit.prevent="createGuest">
        <div class="card text-left">
          <div class="card-body">
            <h5 class="card-title">Guest accounts</h5>
            <h6 class="card-subtitle mb-2 text-muted">One quiz only.</h6>
            <p class="card-text">
              Guest accounts can be used without registration, but will be
              deleted after the first quiz or when 48 hours have passed.
            </p>
            <router-link to="/register" class="card-link"
              >Sign up instead</router-link
            >
          </div>
        </div>

        <h2 class="form-signin-heading py-3">Join TopQuiz as a guest!</h2>

        <label for="createTeamNameInput" class="float-left">Team name</label>
        <b-form-input
          v-model="teamName"
          type="text"
          id="createTeamNameInput"
          class="mb-4"
          placeholder="Team name"
          required
          minlength="3"
          maxlength="100"
          autofocus
        />

        <b-button
          :disabled="isSendingRequest"
          variant="primary"
          block
          type="submit"
          >Enter now</b-button
        >
      </form>

      <div class="mt-3 text-small">
        Got an account already?
        <router-link to="/login">Sign in here</router-link>
      </div>

      <slot name="footer"></slot>
    </div>

    <DialogInfo
      v-model="confirmationVisible"
      v-bind:title="'Welcome ' + userName"
      @hidden="goToDashboard"
    >
      <p>Your guest account has been created. This is your password:</p>
      <p class="font-weight-bold">{{ password }}</p>
      <p>
        Your account will be valid until your first quiz ends or 48 hours have
        passed. You can login with this password above until then.
        <u>Please write it down.</u>
      </p>
    </DialogInfo>

    <DialogError v-model="errorVisible">{{ errorMessage }}</DialogError>
    <!-- /container -->
  </div>
</template>

<script>
import DialogInfo from "@/components/DialogInfo";
import DialogError from "@/components/DialogError";

export default {
  name: "Login",
  components: {
    DialogInfo,
    DialogError
  },
  created() {
    this.$emit("toggle-navbar", false);
    this.$emit("full-body", true);

    this.$topquiz.on(this, "createGuest_success", params => {
      localStorage.setItem("session_key", params[0]);
      this.userName = params[1];
      this.password = params[2];

      this.confirmationVisible = true;
      this.isSendingRequest = false;
    });

    this.$topquiz.on(this, "createGuest_error", params => {
      this.errorMessage = params[0];
      this.errorVisible = true;
      this.isSendingRequest = false;
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  data() {
    return {
      teamName: "",
      userName: "",
      password: "",
      confirmationVisible: false,
      errorMessage: "",
      errorVisible: false,
      isSendingRequest: false
    };
  },
  methods: {
    createGuest() {
      this.isSendingRequest = true;
      this.$topquiz.sendCommand("createGuest", this.teamName);
    },
    goToDashboard() {
      this.$topquiz.checkSession(() => {
        this.$router.replace("/dashboard");
      });
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 400px;
}
</style>
